import {USER_LOGGED_OUT} from "../../user/constants/actionTypes";
import {RELATIVES_ADD, RELATIVES_FETCH} from "../constants/actionTypes";

export const relativesReducer = (state = [], action) => {
  switch (action.type) {
    case USER_LOGGED_OUT:
      return [];
    case RELATIVES_FETCH:
      return [...action.payload];
    case RELATIVES_ADD:
      return [
        ...state,
        {...action.payload}
      ];
    default:
      return state;
  }
};
